import React, { FC } from 'react';

import { Reservation } from 'api-client';
import { ReactComponent as TooltipAlertIcon } from 'assets/images/svg/tooltip-alert.svg';
import { CustomLink, DataTable, Money, ProjectStatusBadge, Tooltip } from 'components/common';
import { ProjectDebtClass } from 'components/project';
import { useProjectRowClick } from 'hooks';
import { RouteDictionary } from 'utils';

import { useMyReservationContent } from '../useMyReservationContent';
import styles from './MyReservationTableRow.module.scss';

interface Props {
  reservation: Reservation;
}

const MyReservationTableRow: FC<Props> = ({ reservation }) => {
  const { project, accounting, money, roiIrr, hasFunds, action } =
    useMyReservationContent(reservation);
  const handleRowClick = useProjectRowClick(project.uuid);

  return (
    <DataTable.Row className={styles.row} onClick={handleRowClick}>
      <DataTable.Cell>
        <CustomLink
          to={RouteDictionary.DETAILED_PROJECT}
          params={{ uuid: project.uuid }}
          className={styles.projectLink}
        >
          <ProjectDebtClass debtClass={project.context.debt.debtClass} />
          <div className={styles.projectName}>{project.name[0].text}</div>
          {accounting.hasExtraCreditorPayment && (
            <div className={styles.projectMeta}>
              <span className={styles.incasso}>инкассо</span>
            </div>
          )}
        </CustomLink>
      </DataTable.Cell>
      <DataTable.Cell align="center">
        <ProjectStatusBadge status={project.status} />
      </DataTable.Cell>
      <DataTable.Cell className={styles.nowrap}>
        <div className={styles.reservationSum}>
          <Money money={money} compact />
          {!hasFunds && (
            <Tooltip
              content="Средств на балансе недостаточно для оплаты резервирования"
              position="top"
            >
              <TooltipAlertIcon className={styles.infoIcon} />
            </Tooltip>
          )}
        </div>
        <div className={styles.caption}>Резервирование</div>
      </DataTable.Cell>
      <DataTable.Cell className={styles.nowrap}>—</DataTable.Cell>
      <DataTable.Cell className={styles.nowrap}>{roiIrr}</DataTable.Cell>
      <DataTable.Cell className={styles.actionCell}>{action}</DataTable.Cell>
    </DataTable.Row>
  );
};

export default MyReservationTableRow;
